import { Accordion, AccordionDetails, AccordionSummary, Box, Divider, Skeleton, Stack } from '@mui/material';
import AccessSessionHeaderSkeleton from '@MyAccess/components/AccessSessionHeaderSkeleton';

export default function AccessSessionListSkeleton() {
  return (
    <Stack spacing={0.5}>
      <Skeleton variant="text" height={45} width={320} />
      <Box />
      <Accordion disableGutters elevation={0} defaultExpanded sx={{ borderRadius: 1, '&:before': { display: 'none' } }}>
        <AccordionSummary>
          <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
            <Skeleton variant="circular" width={20} height={20} />
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={50} height={20} />
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: 0 }}>
          <Divider />
          <Stack padding={1.5} paddingLeft={3}>
            <AccessSessionHeaderSkeleton withArrow />
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
}
